import { Modifier } from '../modifier';
import { actionHistory } from '../../../store';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';
import type { Damage } from '../damage.type';
import { healDamage } from '../player.type';

export class Rebirth extends Modifier {
  static readonly baseTitle = 'Rebirth';
  static readonly baseText = 'On taking lethal damage, heal to the value of stacks, then vanish.';
  static readonly baseIcon = 'rebirth';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Last;

  // Instance properties that can change
  title = Rebirth.baseTitle;
  text = Rebirth.baseText;
  icon = Rebirth.baseIcon;
  tags: Array<ModifierTags> = [...Rebirth.baseTags];
  priority = Rebirth.basePriority;

  damageIn(damage: Damage) {
    // if this.owner.health is less than damage.value, set damage value to 0 and health to stacks
    if (this.owner.healthCurrent < damage.value) {
      damage.value = 0;
      // Set health to 0 first so healDamage heals the correct amount
      this.owner.healthCurrent = 0;
      healDamage({
        value: this.stacks,
        source: this.owner,
        target: this.owner,
        dice: [],
      });
      actionHistory.push(`${this.owner.title} was reborn!`);
      this.removeStacks(this.stacks);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Rebirth, Rebirth);
